import "../styles/index.css";
import 'swiper/css/bundle';

import Sliders from '../components/sliders';
import Home from '../components/home';
import Megamenu from '../components/megamenu';
import Navigator from "../components/navigator";
import Accordion from "../components/accordion";
import PremiumSlider from "../components/premium-slider";
import Tabs from "../components/tabs";
import Lightbox from "../components/lightbox";
import Calendar from "../components/calendar";
import Dropdowns from "../components/dropdown";
import Auth from "../components/auth"
import Stakes from "../components/stakes"
import StakesSchedule from "../components/stakesSchedule"
import Racing from "./racing"
import Scrollsnap from "../components/scrollsnap"
import LightboxGallery from "../components/lightbox-gallery";
import TicketModule from "../components/ticket-module";
import WheelGallery from "../components/wheel-gallery";
import { getCookie } from "../components/cookies";

window.htmx = require('htmx.org')

if (!window.NYRADidInit) {
    Sliders.init()
    Home.init()
    Megamenu.init()
    Navigator.init()
    Accordion.init()
    PremiumSlider.init()
    Tabs.init()
    Lightbox.init()
    Calendar.init()
    Dropdowns.init()
    Auth.init()
    Racing.init()
    Stakes.init()
    /* StakesSchedule.init() */
    Scrollsnap.init()
    LightboxGallery.init()
    TicketModule.init()
    WheelGallery.init()
}
window.NYRADidInit = true

if (typeof CMS !== 'undefined') {
    CMS.$(window).on('cms-content-refresh', function () {
        Sliders.init()
        Accordion.init()
        PremiumSlider.init()
        Tabs.init()
        Dropdowns.init()
        Lightbox.init()
        Auth.init()
        Stakes.init()
        /* StakesSchedule.init() */
        WheelGallery.init()
    })
}

document.body.addEventListener('htmx:afterSwap', (event) => {
    Dropdowns.init()
    const target = event.detail && event.detail.target;
    if (target) {
        const roots = target.matches('[data-accordion-root]')
            ? [target]
            : Array.from(target.querySelectorAll('[data-accordion-root]'));
        roots.forEach(root => Accordion.initAccordion(root));

        const sliderRoots = target.matches('[data-premium-slider-root]')
            ? [target]
            : Array.from(target.querySelectorAll('[data-premium-slider-root]'));
        sliderRoots.forEach(root => PremiumSlider.initPremiumSlider(root));

        const wheelGalleryRoots = target.matches('[data-wheel-gallery-root]')
            ? [target]
            : Array.from(target.querySelectorAll('[data-wheel-gallery-root]'));
        wheelGalleryRoots.forEach(root => WheelGallery.initWheelGallery(root));
    }
    // Any swap that changes content height inside an already-open accordion
    // item (e.g. a lazy-loaded fragment) needs the open-height recomputed.
    // Accordion.initAccordion() already listens for 'resize' to do this.
    window.dispatchEvent(new Event('resize'))
})

// Last Track Masquerade
const masqFlag = document.querySelector('[data-last-track-masquerade]');
if (masqFlag) {
    let mUrl = '/masquerade/';
    const lastTrack = getCookie('last_track');
    if (lastTrack) mUrl += `?track=${lastTrack}`
    htmx.default.ajax('GET', mUrl, {
        target: '[data-track-headers]',
        select: '[data-track-headers]',
        swap:'outerHTML'
    }).then(() => {
        Megamenu.init()
        Navigator.init()
        // Just hardcoding these for now since their well-known and stable
        document.body.classList.remove('theme-none');
        switch (lastTrack) {
            case 'aqueduct':
                document.body.classList.add('theme-aqu');
                break;
            case 'belmont':
                document.body.classList.add('theme-bel');
                break;
            case 'saratoga':
                document.body.classList.add('theme-sar');
                break;
            case 'belmont-stakes':
                document.body.classList.add('theme-bes');
                break;
            default:
                break;
        }
    })
}

// Mobile href handling for button links
document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mobile-href]')
    if (btn) {
        const mobileHref = btn.getAttribute('data-mobile-href');
        if (mobileHref && window.innerWidth < 768) {
            e.preventDefault()
            window.location.href = mobileHref
        }
    }
})